import { useContext } from 'react';

import { StickyContext } from './StickyContext.js';

export const useStickyContext = () => {
  const ctx = useContext(StickyContext);

  if (!ctx) {
    throw new Error('useStickyContext must be used within a StickyContainer');
  }

  return ctx;
};
